export class StripeLogin {
    constructor() {
        this.url = "";
    }
}
